import { shallowMount } from "@vue/test-utils";
import OfferElement from "@/components/core/OfferElement";

describe("OfferElement component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(OfferElement);
  });

  it("Renders del component OfferElement", () => {
    expect(wrapper).toBeDefined();
  });
});
